import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'app/main/globals'; 

@Injectable({
  providedIn: 'root'
})
export class AspLearnWithAutoverseService {

  constructor(private http: HttpClient) {}

  getVideos(language: string, garageKey: string) {
  const params = {
    garageKey: garageKey
  };

  console.log('Fetching videos with:', { garageKey, type: language });

  return this.http.get(
    `${GlobalVariable.BASE_API_URL_SPARES}/spare/video/${language}`,
    { params }
  );
}

}
